module.exports = __webpack_public_path__ + "static/benefit-2-2a825c7c07c035bd1f1398702f8dd720.svg";